'use client'
import {
  Box,
  Flex,
  Avatar,
  Text,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  useDisclosure,
  useColorModeValue,
  Stack,
  useColorMode,
  Center,
  Heading,
  Image
  
} from '@chakra-ui/react'

import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';
import { IconButton, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody,useBreakpointValue } from '@chakra-ui/react';
import { MoonIcon, SunIcon } from '@chakra-ui/icons'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';
import { useEffect, useState } from 'react';

const Navbar = () => {
  const { colorMode, toggleColorMode } = useColorMode()
  const { isOpen, onOpen, onClose } = useDisclosure()
const navigate=useNavigate()
  const loggedInUser = JSON.parse(localStorage.getItem('AI-TextCraftUser'))
  // console.log(loggedInUser.user.name);
  const handleLogout = () => {
    localStorage.removeItem('AI-TextCraftUser');
    navigate('/login');
  };

  const Server=()=>{
    navigate("/history");
  }

  const location = useLocation();
  const [activeRoute, setActiveRoute] = useState('/');

  useEffect(() => {
    setActiveRoute(location.pathname);
  }, [location.pathname]);




   const [isOpe, setIsOpen] = useState(false);
  const display = useBreakpointValue({ base: 'block', md: 'none', });
  const toggleMenu = () => {
    setIsOpen(!isOpe);
  };

  

  return (
    <>
      <Box bg={useColorModeValue('gray.100', 'gray.900')} px={4}>
        <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>
          <Box>
            <Heading as='h1' size='xl' noOfLines={1}   color='tomato'h="50px"  >
            <Link as={RouterLink} to="/" color="teal.500">
      AI-TextCraft
    </Link>
     
  </Heading></Box>

  <Flex alignItems={'center'} gap="3%">
      <Link to="/" >
        <Button
          fontSize="18px" 
          display={{
            base: "none",
            sm: "none",
            md: "flex",
            lg: "flex",
            xl: "flex",
          }}
          bg={activeRoute === '/' ? 'blue.500' : 'transparent'}
        >
          Generate
        </Button>
      </Link>

      <Link to="/consize">
        <Button
          fontSize="18px" 
          display={{
            base: "none",
            sm: "none",
            md: "flex",
            lg: "flex",
            xl: "flex",
          }}
          bg={activeRoute === '/consize' ? 'blue.500' : 'transparent'}
        >
          Consize
        </Button>
      </Link>

      <Link to="/translate">
        <Button
          fontSize="18px"
          display={{
            base: "none",
            sm: "none",
            md: "flex",
            lg: "flex",
            xl: "flex",
          }}
          bg={activeRoute === '/translate' ? 'blue.500' : 'transparent'}
        >
          Translate
        </Button>
      </Link>
      <Link to="/emotion">
        <Button
          fontSize="18px"
          display={{
            base: "none",
            sm: "none",
            md: "flex",
            lg: "flex",
            xl: "flex",
          }}
          bg={activeRoute === '/emotion' ? 'blue.500' : 'transparent'}
        >
          Emotion Recognition
        </Button>
      </Link>
    </Flex>

          <Flex alignItems={'center'}>
            <Stack direction={'row'} spacing={7}>
              <Button onClick={toggleColorMode}>
                {colorMode === 'light' ? <MoonIcon /> : <SunIcon />}
              </Button>

              <Menu>
      <MenuButton
        as={Button}
        rounded={'full'}
        variant={'link'}
        cursor={'pointer'}
        
        minW={0}
        
       
        >
        <Avatar
        
          size={'sm'}
          src={'https://avatars.dicebear.com/api/male/username.svg'}
        />
      </MenuButton>
      {loggedInUser ? (
        <MenuList alignItems={'center'}>
          <br />
          <Center>
            <Avatar
              size={'2xl'}
              src={'https://avatars.dicebear.com/api/male/username.svg'}
            />
          </Center>
          <br />
          <Center>  
            <p>{loggedInUser.user.name}</p>
          </Center>
          <br />
          <MenuDivider />
          <MenuItem onClick={Server} >History</MenuItem>
          {/* <MenuItem>Account Settings</MenuItem> */}
          <MenuItem onClick={handleLogout} >Logout</MenuItem>
        </MenuList>
      ) : (
        <MenuItem onClick={() => navigate('/login')}>Login</MenuItem>
      )}
    </Menu>
            </Stack>
          </Flex>


          {/* Hamburger */}
          <IconButton
            aria-label="Menu"
            icon={isOpe ? <CloseIcon /> : <HamburgerIcon />}
            onClick={toggleMenu}
            variant="ghost"
            display={display}
          />

          {/* Drawer */}
          <Drawer placement="left" onClose={() => setIsOpen(false)} isOpen={isOpe}>
            <DrawerOverlay />
            <DrawerContent>
              <DrawerCloseButton />
              <DrawerHeader>
                <Image
                  cursor="pointer"
                  w="120px"
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSRggu3azDB5aXXmdHoY2t_LjFyTE0VY0ZOgA&usqp=CAU"
                  alt="logo"
                />
              </DrawerHeader>
              <DrawerBody>
              <Flex direction="column">
              <RouterLink to="/">Generate</RouterLink>
              <RouterLink to="/consize">Consize</RouterLink>
              <RouterLink to="/translate">Translate</RouterLink>
              <RouterLink to="/emotion">Emotion</RouterLink>
               
                </Flex>
              </DrawerBody>
            </DrawerContent>
          </Drawer>

{/* hamburger */}


        </Flex>
      </Box>
    </>
  )
}
export default Navbar